<template>
    <el-container class="home_container">
        <el-header>
            <div class="home_title">vawy管理平台</div>
            <div class="home_userinfoContainer">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link home_userinfo"> {{ currentUserName }}<i class="el-icon-arrow-down el-icon--right home_userinfo"></i> </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
        <el-container>
            <el-aside width="200px">
                <el-menu default-active="0" @open="handleOpen" :unique-opened="opened" class="el-menu-vertical-demo" style="background-color: #ECECEC" router>
                    <template v-for="(item, index) in this.$router.options.routes">
                        <template v-if="!item.hidden">
                            <el-submenu :index="index + ''" v-if="item.children.length > 1" :key="index">
                                <template slot="title">
                                    <i :class="item.iconCls"></i>
                                    <span>{{ item.name }}</span>
                                </template>
                                <template v-for="child in item.children">
                                    <el-menu-item v-if="!child.hidden" :index="child.path" :key="child.path">
                                        {{ child.name }}
                                    </el-menu-item>
                                </template>
                            </el-submenu>
                            <template v-else>
                                <el-menu-item :index="item.children[0].path" :key="index">
                                    <i :class="item.children[0].iconCls"></i>
                                    <span slot="title">{{ item.children[0].name }}</span>
                                </el-menu-item>
                            </template>
                        </template>
                    </template>
                </el-menu>
            </el-aside>
            <el-container>
                <el-main>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item v-text="this.$router.currentRoute.name"></el-breadcrumb-item>
                    </el-breadcrumb>
                    <keep-alive>
                        <router-view v-if="this.$route.meta.keepAlive"></router-view>
                    </keep-alive>
                    <router-view v-if="!this.$route.meta.keepAlive"></router-view>
                </el-main>
            </el-container>
        </el-container>
    </el-container>
</template>
<script>
import { getRequest } from '../utils/api';
import { getCurrentUserName } from '@/api';
export default {
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleCommand(command) {
            if (command == 'logout') {
                this.$confirm('注销登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(async () => {
                    this.exitLogin();
                });
            }
        },
        exitLogin() {
            getRequest('/logout');
            this.currentUserName = '游客';
            this.$router.replace({ path: '/' });
        },
    },
    async mounted() {
        try {
            const result = await getCurrentUserName();
            const { data, status } = await getCurrentUserName();
            if (status === 200) {
                this.currentUserName = data;
            } else {
                this.exitLogin();
            }
        } catch (error) {
            this.exitLogin();
        }
    },
    data() {
        return {
            currentUserName: '',
            opened: true,
        };
    },
};
</script>
<style>
.home_container {
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
}

.el-header {
    background-color: #20a0ff;
    color: #333;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.el-aside {
    background-color: #ececec;
}

.el-main {
    background-color: #fff;
    color: #000;
    text-align: center;
}

.home_title {
    color: #fff;
    font-size: 22px;
    display: inline;
}

.home_userinfo {
    color: #fff;
    cursor: pointer;
}

.home_userinfoContainer {
    display: inline;
    margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue